var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgXSocial = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.743 3h3.052l-6.667 7.67L22 21.073h-6.185l-4.819-6.305-5.542 6.305H2.402L9.55 12.88 2 3h6.345l4.378 5.783zm-1.084 16.225h1.686L7.422 4.727H5.574z"
})));
export default SvgXSocial;